import { Col, Row, Table, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { PieChart, Pie, BarChart, XAxis, YAxis, Legend, Bar, Cell } from 'recharts'
import { attackType } from '../../../../shared/enums'
import './css/print-final.css'

import { finalColumns } from '../../../../shared/tables'

const RADIAN = Math.PI / 180
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5
  const x = cx + radius * Math.cos(-midAngle * RADIAN)
  const y = cy + radius * Math.sin(-midAngle * RADIAN)

  return (
    <text x={x} y={y} fill='white' textAnchor={x > cx ? 'start' : 'end'} dominantBaseline='central'>
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  )
}

const COLORS = ['#ea5545', '#f46a9b', '#ef9b20', '#edbf33', '#ede15b', '#bdcf32', '#87bc45', '#27aeef', '#b33dc6']

const PrintFinal = React.forwardRef((props, ref) => {
  const [data, setData] = useState([])
  const [derivedData, setDerivedData] = useState({})

  useEffect(() => {
    const newDerivedData = {
      attacks: []
    }

    const newData = []

    const size = 8
    for (let i = 0; i < Math.ceil(props.participants.length / size); i += 1) {
      const participants = props.participants.slice(i * size, i * size + size)

      const particpantData = participants.map((participant) => {
        Object.keys(participant.stats.advanced.for).forEach(key => {
          const index = newDerivedData.attacks.findIndex(a => a.id === key)
          if (index < 0) {
            newDerivedData.attacks.push({
              id: key,
              value: participant.stats.advanced.for[key],
              name: attackType[key.toLowerCase()].name
            })
          }
        })
        return Object.assign({}, participant, { full_name: `${participant.last_name}, ${participant.first_name}` })
      })
      newData.push(particpantData)
    }

    setData(newData)
    setDerivedData(newDerivedData)
    // eslint-disable-next-line
  }, [props.participants])

  return (
    <div ref={ref} className='print' id='final'>
      <div style={{ marginTop: '1em', textAlign: 'center' }}><h2>Tournament Rating: {props.tournament.rating}</h2></div>
      <Table dataSource={props.participants} columns={finalColumns.filter(c => c.display)} key='uuid' pagination={false} size='small' />
      <Row style={{ padding: '2em 0' }}>
        {derivedData?.attacks?.length > 0
          ? (
            <Col span={24}>
              <PieChart width={400} height={400} style={{ marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}>
                <Legend />
                <Pie
                  data={derivedData.attacks}
                  dataKey='value'
                  cx='50%'
                  cy='50%'
                  labelLine={false}
                  label={renderCustomizedLabel}
                  fill='#8884d8'
                  isAnimationActive={false}
                >
                  {derivedData?.attacks?.map((entry, index) => {
                    return <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  })}
                </Pie>
              </PieChart>
            </Col>
            )
          : ''}
        {data.map((d, index) => (
          <Col key={`data_${index}`} span={24}>
            <BarChart
              width={1000}
              height={400}
              data={d}
              style={{ marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}
              isAnimationActive={false}
            >
              <XAxis dataKey='full_name' />
              <YAxis yAxisId='left' orientation='left' stroke='#0d88e6' />
              <YAxis yAxisId='right' orientation='right' stroke='#ef9b20' />
              <Tooltip />
              <Legend />
              <Bar dataKey='stats.standard.for' yAxisId='left' name='Points' fill={COLORS[0]} />
              <Bar dataKey='stats.standard.wins' yAxisId='right' name='Wins' fill={COLORS[5]} />
              <Bar dataKey='stats.honor' yAxisId='right' name='Honor' fill={COLORS[8]} />
            </BarChart>
          </Col>
        ))}

      </Row>
    </div>
  )
})

export default PrintFinal
